import React from 'react';
export const Hero: React.FC = () => {
  return <section id="intro" className="h-screen max-h-[800px] sm:max-h-none sm:min-h-screen flex items-center justify-center bg-cover bg-center relative" style={{
    backgroundImage: 'url(https://uploadthingy.s3.us-west-1.amazonaws.com/rUQF6Uf2VmBJQJzUwZbaDt/pasted-image.jpg)'
  }} data-id="element-136">
      {/* Preload hero image for faster loading */}
      <link rel="preload" as="image" href="https://uploadthingy.s3.us-west-1.amazonaws.com/rUQF6Uf2VmBJQJzUwZbaDt/pasted-image.jpg" data-id="element-137" />

      {/* Lighter, more subtle dreamy overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-rose-200/8 to-black/25" data-id="element-138" />
      <div className="absolute inset-0 bg-white/3" data-id="element-139" />

      <div className="relative z-10 text-center text-white px-4 sm:px-6 lg:px-8 w-full" data-id="element-140">
        <h2 className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-6xl font-serif mb-6 sm:mb-8 tracking-tight sm:tracking-normal md:tracking-wide leading-tight mx-auto sm:whitespace-nowrap" data-id="element-141">
          Crafting Timeless <br className="sm:hidden" data-id="element-142" />
          Love&nbsp;Stories
        </h2>
        <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl italic font-light leading-relaxed max-w-6xl mx-auto" data-id="element-143">
          From intimate ceremonies to grand celebrations,{' '}
          <strong className="font-normal" data-id="element-144">Moonstone Events</strong> brings your
          vision to life with artistry, care, and intention.
        </p>
      </div>
    </section>;
};